import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "style", "id", "icon", "onClose", "color", "closable", "size", "type", "disabled", "label", "children", "title"];
import * as React from 'react';
import { useEffect } from 'react';
import classNames from 'classnames';
import { KEY_VALUES, setupGetInstanceId, mergeRefs } from '../utils';
import { useLocalization } from '@appkit4/react-api';
var getInstanceId = setupGetInstanceId();
var Tag = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var customizePrefixCls = _ref.prefixCls,
    className = _ref.className,
    style = _ref.style,
    id = _ref.id,
    icon = _ref.icon,
    onClose = _ref.onClose,
    color = _ref.color,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'filled' : _ref$type,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    label = _ref.label,
    children = _ref.children,
    title = _ref.title,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  var tagRef = React.useRef(null);
  useEffect(function () {
    var ele = tagRef === null || tagRef === void 0 ? void 0 : tagRef.current;
    if (ele) {
      if (type === 'filled') {
        ele.style.setProperty('--tag-text-color', 'var(--color-text-tertiary)');
      } else {
        ele.style.setProperty('--tag-text-color', 'var(--color-text-primary)');
      }
      ele.style.setProperty('--tag-background-color', 'var(--color-background-primary-rgb)');
      ele.style.setProperty('--tag-border-color', 'var(--color-background-primary)');
      if (color) {
        ele.style.setProperty('--tag-background-color', colorDetector(color));
        ele.style.setProperty('--tag-border-color', color);
      }
    }
  }, [color, type]);
  var colorDetector = function colorDetector(color) {
    // color detctor and color convert
    // if color is hexcode, transform is as rgba
    // if color is rgb / rgba / text, continue

    var isHexcode = /^#([0-9a-f]{3}){1,2}$/i;
    if (color && isHexcode.test(color)) {
      return hexcodeToRgba(color);
    } else {
      return color;
    }
  };
  var hexcodeToRgba = function hexcodeToRgba(hex, alpha) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) || [];
    // if hex code is #415385
    // result would be ["#415385", "41", "53", "85"]

    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    return result ? r + ", " + g + ", " + b : '';
  };
  var prefixCls = customizePrefixCls ? customizePrefixCls + "-tag" : 'ap-tag';
  var tagId = id || "tag-" + getInstanceId();
  var tagClassName = classNames(prefixCls, 'ap-tag-default', className, (_classNames = {}, _classNames[prefixCls + "-" + size] = size, _classNames[prefixCls + "-disabled"] = disabled, _classNames[prefixCls + "-" + type] = type, _classNames));

  // const tagStyle = {
  //   backgroundColor: color ? color : undefined,
  //   ...style,
  // };

  var handleCloseClick = function handleCloseClick(event) {
    event.stopPropagation();
    if (onClose) {
      onClose(event);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var key = event.key;
    if (KEY_VALUES.SPACE === key || KEY_VALUES.ENTER === key) {
      event.preventDefault();
      if (onClose) {
        onClose(event);
      }
    }
  };
  var renderCloseIcon = function renderCloseIcon() {
    if (closable) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "ap-tag-delete-icon",
        title: title || t("clear"),
        disabled: disabled,
        "aria-disabled": disabled,
        "aria-labelledby": tagId,
        onClick: disabled ? undefined : handleCloseClick,
        onKeyDown: disabled ? undefined : handleKeyDown
      }, /*#__PURE__*/React.createElement("i", {
        className: "Appkit4-icon icon-circle-delete-fill"
      }));
    }
    return null;
  };
  var ariaLabel = label;
  if (!ariaLabel) {
    typeof children === 'string' ? ariaLabel = children : ariaLabel = children === null || children === void 0 ? void 0 : children.toString();
  }
  var tagNode = /*#__PURE__*/React.createElement("div", _extends({
    ref: mergeRefs(ref, tagRef),
    className: tagClassName,
    id: tagId
    // style={tagStyle}
    ,
    style: _extends({}, style),
    "aria-label": ariaLabel
  }, props), icon, /*#__PURE__*/React.createElement("span", {
    className: prefixCls + "-label",
    title: ariaLabel
  }, label || children), renderCloseIcon());
  return tagNode;
});
Tag.displayName = 'Tag';
export default Tag;